(function () {
  angular
    .module("akitabox.mobile")
    .controller("MobileController", MobileController);

  /** @ngInject */
  function MobileController(
    // Angular
    $scope,
    $state,
    $timeout,
    // Services
    CustomerAccountService,
    OrganizationService,
    BuildingService,
    AppcuesService,
    RedirectService,
    FeatureFlagService,
    // Dialogs
    UpdateIdentityNamesDialog,
    Utils
  ) {
    var self = this;

    // Attributes
    self.organization = OrganizationService.getCurrent();
    self.building = BuildingService.getCurrent();
    self.state = $state.current.name;
    self.showBuildings = !$state.includes("app.dashboard");

    self.organizationCount = null;
    self.loading = true;

    // Functions
    self.getSuperHeaderText = getSuperHeaderText;
    self.selectOrganization = selectOrganization;
    self.selectBuilding = selectBuilding;

    init();

    // ------------------------
    //   Events
    // ------------------------

    $scope.$on(
      "$locationChangeSuccess",
      angular.debounce(function () {
        // Prevent this callback from running if the component has
        // been destroyed, as it may have unintended effects that result
        // in errors
        self.showBuildings = !$state.includes("app.dashboard");
        if (!$state.includes("app.building")) {
          self.building = null;
          BuildingService.setCurrent(null);
        }
      }, 500)
    );

    $scope.$on("building:change", function (event, building) {
      self.building = building;
    });

    self.$onInit = function () {
      // Attempt to show the UpdateIdentityNamesDialog, see method for logic
      UpdateIdentityNamesDialog.show();
    };

    // ------------------------
    //   Initialization
    // ------------------------

    function init() {
      AppcuesService.init();
      OrganizationService.get({ count: true })
        .then(function (result) {
          self.organizationCount = result.count;
          self.loading = false;
        })
        .then(CustomerAccountService.getActiveTheme)
        .then((theme) => {
          $timeout(() => {
            // If the customer account has no active theme, show the help button
            if (!theme) {
              var helpIconElement = document.querySelector("#help-button");
              if (helpIconElement) {
                helpIconElement.style.display = "flex";
              }
            }
          });
        });
    }

    // ------------------------
    //   Public Functions
    // ------------------------

    function getSuperHeaderText() {
      if (self.organization) {
        return self.organization.name;
      } else if (self.organizationCount === 0) {
        return "AkitaBox";
      }
      return null;
    }

    function selectBuilding($event) {
      var building = $event.building || $event.model;
      self.building = building;
      $state.go("app.building.detail", { buildingId: self.building._id });
    }

    function selectOrganization($event) {
      var organization = $event.organization || $event.model;

      if (!Utils.isSameModel(organization, self.organization)) {
        RedirectService.redirectToOrganization(organization, "/m");
        return;
      }
    }
  }
})();
